/* tslint:disable */
import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpRequest,
  HttpResponse,
  HttpHeaders,
} from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { Setting } from '../models/setting';
import { JsonNode } from '../models/json-node';

/**
 * Ui Settings Controller
 */
@Injectable({
  providedIn: 'root',
})
class UiSettingsControllerService extends __BaseService {
  static readonly getAllSettingsForEntityUsingGETPath =
    '/cc-ui/v1/settings/entity/{entity}';
  static readonly setOnboardingDisplayUsingPUTPath =
    '/cc-ui/v1/settings/onboarding-display/{value}';
  static readonly getAllSettingsYamlUsingGETPath = '/cc-ui/v1/settings/ui-yaml';
  static readonly getSettingValueUsingGETPath =
    '/cc-ui/v1/settings/value/{entityType}/{entityId}';
  static readonly addSettingValueUsingPUTPath =
    '/cc-ui/v1/settings/value/{entityType}/{entityId}';

  constructor(config: __Configuration, http: HttpClient) {
    super(config, http);
  }

  /**
   * getAllSettingsForEntity
   * @param entity entity
   * @return OK
   */
  getAllSettingsForEntityUsingGETResponse(
    entity:
      | 'CLUSTER'
      | 'BLUE_PRINT'
      | 'TEMPLATE_INPUT'
      | 'CONTROL_PLANE'
      | 'IAC'
      | 'ARTIFACT_CI'
      | 'USER_GROUP'
      | 'ACCOUNT'
      | 'ARTIFACTORY',
  ): __Observable<__StrictHttpResponse<Array<Setting>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/settings/entity/${encodeURIComponent(String(entity))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<Setting>>;
      }),
    );
  }
  /**
   * getAllSettingsForEntity
   * @param entity entity
   * @return OK
   */
  getAllSettingsForEntityUsingGET(
    entity:
      | 'CLUSTER'
      | 'BLUE_PRINT'
      | 'TEMPLATE_INPUT'
      | 'CONTROL_PLANE'
      | 'IAC'
      | 'ARTIFACT_CI'
      | 'USER_GROUP'
      | 'ACCOUNT'
      | 'ARTIFACTORY',
  ): __Observable<Array<Setting>> {
    return this.getAllSettingsForEntityUsingGETResponse(entity).pipe(
      __map((_r) => _r.body as Array<Setting>),
    );
  }

  /**
   * setOnboardingDisplay
   * @param value value
   */
  setOnboardingDisplayUsingPUTResponse(
    value: boolean,
  ): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl +
        `/cc-ui/v1/settings/onboarding-display/${encodeURIComponent(
          String(value),
        )}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      }),
    );
  }
  /**
   * setOnboardingDisplay
   * @param value value
   */
  setOnboardingDisplayUsingPUT(value: boolean): __Observable<null> {
    return this.setOnboardingDisplayUsingPUTResponse(value).pipe(
      __map((_r) => _r.body as null),
    );
  }

  /**
   * getAllSettingsYaml
   * @return OK
   */
  getAllSettingsYamlUsingGETResponse(): __Observable<
    __StrictHttpResponse<JsonNode>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/cc-ui/v1/settings/ui-yaml`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<JsonNode>;
      }),
    );
  }
  /**
   * getAllSettingsYaml
   * @return OK
   */
  getAllSettingsYamlUsingGET(): __Observable<JsonNode> {
    return this.getAllSettingsYamlUsingGETResponse().pipe(
      __map((_r) => _r.body as JsonNode),
    );
  }

  /**
   * getSettingValue
   * @param params The `UiSettingsControllerService.GetSettingValueUsingGETParams` containing the following parameters:
   *
   * - `entityType`: entityType
   *
   * - `entityId`: entityId
   *
   * @return OK
   */
  getSettingValueUsingGETResponse(
    params: UiSettingsControllerService.GetSettingValueUsingGETParams,
  ): __Observable<__StrictHttpResponse<{}>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/settings/value/${encodeURIComponent(
          String(params.entityType),
        )}/${encodeURIComponent(String(params.entityId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<{}>;
      }),
    );
  }
  /**
   * getSettingValue
   * @param params The `UiSettingsControllerService.GetSettingValueUsingGETParams` containing the following parameters:
   *
   * - `entityType`: entityType
   *
   * - `entityId`: entityId
   *
   * @return OK
   */
  getSettingValueUsingGET(
    params: UiSettingsControllerService.GetSettingValueUsingGETParams,
  ): __Observable<{}> {
    return this.getSettingValueUsingGETResponse(params).pipe(
      __map((_r) => _r.body as {}),
    );
  }

  /**
   * addSettingValue
   * @param params The `UiSettingsControllerService.AddSettingValueUsingPUTParams` containing the following parameters:
   *
   * - `settingValueRequest`: settingValueRequest
   *
   * - `entityType`: entityType
   *
   * - `entityId`: entityId
   *
   * @return OK
   */
  addSettingValueUsingPUTResponse(
    params: UiSettingsControllerService.AddSettingValueUsingPUTParams,
  ): __Observable<__StrictHttpResponse<{}>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.settingValueRequest;

    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl +
        `/cc-ui/v1/settings/value/${encodeURIComponent(
          String(params.entityType),
        )}/${encodeURIComponent(String(params.entityId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<{}>;
      }),
    );
  }
  /**
   * addSettingValue
   * @param params The `UiSettingsControllerService.AddSettingValueUsingPUTParams` containing the following parameters:
   *
   * - `settingValueRequest`: settingValueRequest
   *
   * - `entityType`: entityType
   *
   * - `entityId`: entityId
   *
   * @return OK
   */
  addSettingValueUsingPUT(
    params: UiSettingsControllerService.AddSettingValueUsingPUTParams,
  ): __Observable<{}> {
    return this.addSettingValueUsingPUTResponse(params).pipe(
      __map((_r) => _r.body as {}),
    );
  }
}

module UiSettingsControllerService {
  /**
   * Parameters for getSettingValueUsingGET
   */
  export interface GetSettingValueUsingGETParams {
    /**
     * entityType
     */
    entityType:
      | 'CLUSTER'
      | 'BLUE_PRINT'
      | 'TEMPLATE_INPUT'
      | 'CONTROL_PLANE'
      | 'IAC'
      | 'ARTIFACT_CI'
      | 'USER_GROUP'
      | 'ACCOUNT'
      | 'ARTIFACTORY';

    /**
     * entityId
     */
    entityId: string;
  }

  /**
   * Parameters for addSettingValueUsingPUT
   */
  export interface AddSettingValueUsingPUTParams {
    /**
     * settingValueRequest
     */
    settingValueRequest: {};

    /**
     * entityType
     */
    entityType:
      | 'CLUSTER'
      | 'BLUE_PRINT'
      | 'TEMPLATE_INPUT'
      | 'CONTROL_PLANE'
      | 'IAC'
      | 'ARTIFACT_CI'
      | 'USER_GROUP'
      | 'ACCOUNT'
      | 'ARTIFACTORY';

    /**
     * entityId
     */
    entityId: string;
  }
}

export { UiSettingsControllerService };
